import { InjectionToken } from '@angular/core';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';
import { Observable } from 'rxjs';

export interface BdPermissionsRequest {
  shareableType: ShareableType;
  shareableId: string;
  shareableName?: string;
}

/**
 * Opens the "Zugriff" dialog for a single shareable — the read-only view that
 * lists who currently has access (plus pending access requests) and lets the
 * user drill into a single grant's detailed permission breakdown.
 *
 * Emits exactly once (`void`) when the dialog closes; the caller does not need
 * a result because the dialog only displays/forwards access information and
 * never mutates the shareable itself.
 *
 * The implementation lives in `@bindoc-projects/resource-lib/registration` so apps that don't need the
 * grant flow don't pull the TreeTable/preview machinery into their eager
 * bundle. Apps that need it should provide the token via
 * `providePermissionsDialog()` (exported from `@bindoc-projects/resource-lib/registration`).
 */
export type BdPermissionsOpener = (
  request: BdPermissionsRequest,
) => Observable<void>;

export const BD_PERMISSIONS_OPENER = new InjectionToken<BdPermissionsOpener>(
  'BD_PERMISSIONS_OPENER',
);
